import React from 'react'
import {useRouteLoaderData} from '@remix-run/react'
import clsx from 'clsx'
import type {FunctionComponent, HTMLAttributes} from 'react'
import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types'

export interface DiscountBadgeProps extends HTMLAttributes<HTMLDivElement> {
  discount?: number
  source?: string
}

export const DiscountBadge: FunctionComponent<DiscountBadgeProps> = ({discount, source, ...props}) => {
  const {locale, language} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)
  return (
    <div {...props}>
      <p className={clsx(locale.toLocaleLowerCase() === 'de' && 'mobile:before:content-["-"]')}>
        {translations.Badge.discountAmount(discount)}
        <em className={clsx('ml-1 not-italic', locale.toLocaleLowerCase() === 'de' && 'mobile:hidden')}>
          {translations.Badge.off}
        </em>
      </p>
    </div>
  )
}
